/**
 * HOCHZEIT PREVIEW GLOSSY - Canvas-basierte Live-Vorschau
 * Zeigt personalisierte Hochzeits-Produkte mit Echtzeit-Rendering
 * Version für Glossy-Töpfe mit eigenem Vorschaubild
 */

const HochzeitPreviewGlossy = {
  // ========================================
  // KONFIGURATION (ANPASSBAR!)
  // ========================================
  config: {
    // Base-Produktbild (Glossy Version)
    baseImage: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/Design_ohne_Titel_66ee0c6a-60fb-4b36-8140-de8eb85a9694.png?v=1766134751',

    // Canvas-Dimensionen
    canvasWidth: 800,
    canvasHeight: 800,

    // Hochzeits-Motiv-URLs (1-27)
    motivUrls: {
      1: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/1_e5177a5a-b5b9-42c5-b88e-e13971849843.png?v=1761660452',
      2: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/2_195df290-731c-4502-bcb8-982a69d468ac.png?v=1761660451',
      3: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/3_639eb490-8473-4a65-84a0-a709e464f36e.png?v=1761660453',
      4: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/4_37e0afad-6e25-4685-adea-9443a3e576b5.png?v=1761660451',
      5: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/5_655a41a9-8fcd-4e18-b3f9-1f4072840076.png?v=1761660451',
      6: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/6_088a4d5a-7041-4c69-9dec-126c3b3384a1.png?v=1761660451',
      7: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/7_5d86987f-179f-4aca-b977-87fae1bb206a.png?v=1761660452',
      8: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/8_decd04bb-49ab-43ca-8b50-5ffc423c5964.png?v=1761660452',
      9: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/9_cbd1b00c-fb9c-4077-838a-12a5fc8d75a6.png?v=1761660452',
      10: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/10_79d85b2e-3596-4bdf-b758-7abb9b865e7d.png?v=1761660452',
      11: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/11_2991b18a-073e-4077-a6e9-b039c61b4d93.png?v=1761660453',
      12: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/12_8abaf319-3f16-46c1-ba57-9c7215ebc4a3.png?v=1761660452',
      13: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/13_926df319-36d4-4a62-b813-723fae37d6fc.png?v=1761660452',
      14: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/14_95dcc7f0-79d3-43a2-a751-57342319cf4d.png?v=1761660451',
      15: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/15_5b153037-552f-4023-9256-c9555f2befd3.png?v=1761660453',
      16: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/16_f8f40bab-2ffa-47d7-9b2c-49957294d761.png?v=1761660451',
      17: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/17_654c7482-23b9-4b48-8ce4-a4085b388bb8.png?v=1761660453',
      18: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/18_7f80adf6-7e0e-4522-bfda-69501fc7e0d4.png?v=1761660452',
      19: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/19_6b7d5e41-f4fb-459b-8634-ebacf4e4bdf3.png?v=1761660452',
      20: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/20_c492d967-728d-4d82-977e-bd88e6e55d92.png?v=1761660452',
      21: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/21_c2a912db-dbff-40e1-812f-edf6f6e1fd3d.png?v=1761660451',
      22: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/22_c3f8e665-b735-4430-b0a0-23cce69986cb.png?v=1761660452',
      23: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/23_0b494142-8004-48a2-b5f5-de4dd212589a.png?v=1761660452',
      24: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/24_906193f5-6720-4a1f-b5b4-13db616ea6d0.png?v=1761660452',
      25: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/25_feb031b6-e466-42c3-8aa5-8871b657938d.png?v=1761660451',
      26: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/26_3e33b847-d811-4ebc-bde4-0033a320ffe3.png?v=1761660452',
      27: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/27_8e4622e2-490f-46ef-bf91-0b96685bc49e.png?v=1761660453'
    },

    // Text-Positionen und Styles (basierend auf Mustergravur-Bild)
    textConfig: {
      vornamen: {
        x: 400,           // Zentriert
        y: 580,           // Namen in der Mitte (unter dem Motiv) - etwas nach oben
        fontSize: 72,     // Noch größer für Lovely Font
        fontFamily: 'Lovely',
        color: '#4a4a4a', // Dunkelgrau wie im Musterbild
        align: 'center',
        baseline: 'middle'
      },
      datum: {
        x: 400,
        y: 670,           // Datum unter den Namen - weiter nach unten
        fontSize: 42,     // Etwas größer für Poppins Black
        fontFamily: 'Poppins Black',
        color: '#3a3a3a', // Etwas dunkler für bessere Lesbarkeit
        align: 'center',
        baseline: 'middle'
      }
    },

    // Motiv-Position und Größe (oben auf dem Topf)
    motivConfig: {
      x: 400,             // Zentriert
      y: 425,             // Oben (über den Namen) - weiter nach unten
      maxWidth: 200,      // Etwas kleiner als birthtree
      maxHeight: 200      // Etwas kleiner als birthtree
    }
  },

  // Interner State
  canvas: null,
  ctx: null,
  images: {
    base: null,
    motiv: null
  },
  fontsLoaded: false,
  isRendering: false,

  /**
   * Initialisierung
   */
  init() {
    // Canvas-Element finden
    this.canvas = document.getElementById('hz-preview-canvas');
    if (!this.canvas) {
      console.error('HZ: Canvas element not found');
      return;
    }

    this.ctx = this.canvas.getContext('2d');

    // Event Listeners registrieren
    this.setupEventListeners();

    // Fonts vorladen
    this.loadFonts();

    // Base Image vorladen
    this.loadBaseImage();

    // Warenkorb-Integration einrichten
    this.setupCartIntegration();

    console.log('HochzeitPreview initialized');
  },

  /**
   * Event Listeners einrichten
   */
  setupEventListeners() {
    // Vorschau-Button
    const previewBtn = document.getElementById('hz-preview-btn');
    if (previewBtn) {
      previewBtn.addEventListener('click', () => this.openPreview());
    }

    // Modal schließen
    const closeBtn = document.querySelector('.hz-preview-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.closePreview());
    }

    // Modal-Hintergrund klicken
    const modal = document.getElementById('hz-preview-modal');
    if (modal) {
      modal.addEventListener('click', (e) => {
        if (e.target.id === 'hz-preview-modal') {
          this.closePreview();
        }
      });
    }

    // ESC-Taste zum Schließen
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closePreview();
      }
    });
  },

  /**
   * Fonts laden und auf Bereitschaft warten
   */
  async loadFonts() {
    try {
      // Warten bis Fonts geladen sind
      await document.fonts.ready;

      // Fonts explizit laden
      await document.fonts.load('48px Lovely');
      await document.fonts.load('42px "Poppins Black"');

      this.fontsLoaded = true;
      console.log('✓ HZ: Fonts loaded successfully');
    } catch (error) {
      console.error('HZ: Error loading fonts:', error);
      this.fontsLoaded = true; // Trotzdem weitermachen
    }
  },

  /**
   * Base-Produktbild vorladen
   */
  loadBaseImage() {
    this.images.base = new Image();
    this.images.base.crossOrigin = 'anonymous';

    this.images.base.onload = () => {
      console.log('✓ HZ: Base image loaded');
    };

    this.images.base.onerror = () => {
      console.error('✗ HZ: Failed to load base image');
    };

    this.images.base.src = this.config.baseImage;
  },

  /**
   * Motiv-Bild laden
   */
  loadMotiv(motivNumber) {
    return new Promise((resolve, reject) => {
      if (!motivNumber) {
        this.images.motiv = null;
        resolve();
        return;
      }

      const motivUrl = this.config.motivUrls[motivNumber];

      if (!motivUrl) {
        console.error(`HZ: Motiv ${motivNumber} not found`);
        this.images.motiv = null;
        resolve();
        return;
      }

      this.images.motiv = new Image();
      this.images.motiv.crossOrigin = 'anonymous';

      this.images.motiv.onload = () => {
        console.log(`✓ HZ: Motiv ${motivNumber} loaded`);
        resolve();
      };

      this.images.motiv.onerror = () => {
        console.error(`✗ HZ: Failed to load motiv ${motivNumber}`);
        this.images.motiv = null;
        resolve(); // Trotzdem weitermachen
      };

      this.images.motiv.src = motivUrl;
    });
  },

  /**
   * Vorschau-Modal öffnen
   */
  async openPreview() {
    if (this.isRendering) return;

    // Validierung
    const formData = this.getFormData();
    if (!formData.vornamen || !formData.datum || !formData.motiv) {
      alert('Bitte fülle alle Felder aus (Vornamen, Datum und Motiv)');
      return;
    }

    // Felder mit Warenkorb synchronisieren
    this.syncFieldsToCart();

    const modal = document.getElementById('hz-preview-modal');
    const loading = document.getElementById('hz-preview-loading');
    const canvas = this.canvas;

    // Modal anzeigen
    modal.classList.add('active');
    loading.style.display = 'block';
    canvas.style.display = 'none';

    // Kurz warten für Modal-Animation
    await new Promise(resolve => setTimeout(resolve, 100));

    // Vorschau rendern
    await this.renderPreview();

    // Canvas anzeigen
    loading.style.display = 'none';
    canvas.style.display = 'block';
  },

  /**
   * Vorschau-Modal schließen
   */
  closePreview() {
    const modal = document.getElementById('hz-preview-modal');
    modal.classList.remove('active');
  },

  /**
   * Form-Daten auslesen
   */
  getFormData() {
    // Motiv aus Radio Buttons auslesen
    const motivRadio = document.querySelector('input[name="hz-motiv"]:checked');

    // Datum konvertieren von YYYY-MM-DD zu DD.MM.YYYY
    const datumInput = document.getElementById('hz-datum')?.value || '';
    let datumFormatted = '';
    if (datumInput) {
      const [year, month, day] = datumInput.split('-');
      datumFormatted = `${day}.${month}.${year}`;
    }

    return {
      vornamen: document.getElementById('hz-vornamen')?.value || '',
      datum: datumFormatted,
      motiv: motivRadio?.value || '',
      samen: document.getElementById('hz-samen')?.value || ''
    };
  },

  /**
   * Warenkorb-Integration einrichten
   */
  setupCartIntegration() {
    // Hidden Fields ins Product Form einfügen
    const productForm = document.querySelector('form[action*="/cart/add"]');
    const hiddenFields = document.getElementById('hz-hidden-fields');

    if (productForm && hiddenFields) {
      // Hidden Fields ins Form verschieben
      productForm.appendChild(hiddenFields);
      console.log('✓ HZ: Hidden fields moved to product form');
    } else {
      console.warn('⚠ HZ: Product form or hidden fields not found');
    }

    // Bei Input-Änderungen automatisch synchronisieren
    const inputs = document.querySelectorAll('.hz-input');
    inputs.forEach(input => {
      input.addEventListener('change', () => this.syncFieldsToCart());
      input.addEventListener('blur', () => this.syncFieldsToCart());
    });

    // Bei Radio Button Änderungen synchronisieren
    const radioButtons = document.querySelectorAll('input[name="hz-motiv"]');
    radioButtons.forEach(radio => {
      radio.addEventListener('change', () => this.syncFieldsToCart());
    });

    // Bei Form Submit synchronisieren
    if (productForm) {
      productForm.addEventListener('submit', () => {
        this.syncFieldsToCart();
      });
    }

    console.log('✓ HZ: Cart integration setup complete');
  },

  /**
   * Felder mit Hidden Fields synchronisieren
   */
  syncFieldsToCart() {
    const formData = this.getFormData();

    // Hidden hz-motiv Field aktualisieren (für Rückwärtskompatibilität)
    const hiddenMotivField = document.getElementById('hz-motiv');
    if (hiddenMotivField) {
      hiddenMotivField.value = formData.motiv;
    }

    // Werte in Hidden Fields kopieren
    const hiddenFields = {
      'hz-hidden-vornamen': formData.vornamen,
      'hz-hidden-datum': formData.datum,
      'hz-hidden-motiv': formData.motiv ? `Motiv ${formData.motiv}` : '',
      'hz-hidden-samen': formData.samen
    };

    Object.keys(hiddenFields).forEach(id => {
      const field = document.getElementById(id);
      if (field) {
        field.value = hiddenFields[id];
      }
    });

    console.log('✓ HZ: Fields synced to cart:', formData);
  },

  /**
   * Hauptfunktion: Vorschau rendern
   */
  async renderPreview() {
    if (this.isRendering) return;
    this.isRendering = true;

    try {
      const ctx = this.ctx;
      const canvas = this.canvas;

      // Canvas leeren
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // 1. Base-Bild zeichnen
      if (this.images.base && this.images.base.complete) {
        ctx.drawImage(this.images.base, 0, 0, canvas.width, canvas.height);
      } else {
        // Fallback: Weißer Hintergrund
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        console.warn('HZ: Base image not loaded, using white background');
      }

      // Form-Daten holen
      const formData = this.getFormData();

      // 2. Motiv laden und zeichnen (wenn ausgewählt)
      if (formData.motiv) {
        await this.loadMotiv(formData.motiv);
        this.drawMotiv();
      }

      // 3. Vornamen zeichnen (in Lovely Font)
      if (formData.vornamen) {
        this.drawText('vornamen', formData.vornamen);
      }

      // 4. Datum zeichnen (in Poppins Black)
      if (formData.datum) {
        this.drawText('datum', formData.datum);
      }

      console.log('✓ HZ: Preview rendered successfully');
    } catch (error) {
      console.error('HZ: Error rendering preview:', error);
    } finally {
      this.isRendering = false;
    }
  },

  /**
   * Text zeichnen
   */
  drawText(fieldName, text) {
    if (!text) return;

    const config = this.config.textConfig[fieldName];
    if (!config) return;

    const ctx = this.ctx;

    // Font-Style setzen (mit bold für vornamen)
    const fontWeight = fieldName === 'vornamen' ? 'bold ' : '';
    ctx.font = `${fontWeight}${config.fontSize}px "${config.fontFamily}"`;
    ctx.fillStyle = config.color;
    ctx.textAlign = config.align;
    ctx.textBaseline = config.baseline;

    // Text-Schatten für bessere Lesbarkeit
    ctx.shadowColor = 'rgba(255, 255, 255, 0.3)';
    ctx.shadowBlur = 3;
    ctx.shadowOffsetX = 1;
    ctx.shadowOffsetY = 1;

    // Text zeichnen
    ctx.fillText(text, config.x, config.y);

    // Schatten zurücksetzen
    ctx.shadowColor = 'transparent';
    ctx.shadowBlur = 0;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;
  },

  /**
   * Motiv zeichnen
   */
  drawMotiv() {
    if (!this.images.motiv) return;

    const config = this.config.motivConfig;
    const motiv = this.images.motiv;

    // Skalierung berechnen (aspect ratio beibehalten)
    let width = motiv.width;
    let height = motiv.height;

    const scale = Math.min(
      config.maxWidth / width,
      config.maxHeight / height,
      1 // Nicht größer als Original
    );

    width *= scale;
    height *= scale;

    // Zentriert an Position zeichnen
    this.ctx.drawImage(
      motiv,
      config.x - width / 2,
      config.y - height / 2,
      width,
      height
    );
  }
};

// Auto-Initialisierung wenn DOM bereit
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => HochzeitPreviewGlossy.init());
} else {
  HochzeitPreviewGlossy.init();
}

// Für Debugging im Browser-Console
window.HochzeitPreviewGlossy = HochzeitPreviewGlossy;
